// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__17OF4","actions":"GroupTable_actions__2wNSY","deleteModalFooter":"GroupTable_deleteModalFooter__1IW1z"};